import { lazy } from 'solid-js'
import { messages } from '../../pages/faq-page/faq-page-routing.messages.en.js'

export default {
    children: [
        // handle /faq
        {
            path: '',
        },
        {
            descriptionMessage: messages.descriptionMessageGeneral,
            path: '/general',
            titleMessage: messages.titleMessageGeneral,
        },
        {
            descriptionMessage: messages.descriptionMessageBookings,
            path: '/bookings',
            titleMessage: messages.titleMessageBookings,
        },
        {
            descriptionMessage: messages.descriptionMessagePricing,
            path: '/pricing',
            titleMessage: messages.titleMessagePricing,
        },
        {
            descriptionMessage: messages.descriptionMessageHosting,
            path: '/hosting',
            titleMessage: messages.titleMessageHosting,
        },
        {
            descriptionMessage: messages.descriptionMessageCancellation,
            path: '/cancellation',
            titleMessage: messages.titleMessageCancellation,
        },
        {
            descriptionMessage: messages.descriptionMessagePoints,
            path: '/points',
            titleMessage: messages.titleMessagePoints,
        },
        {
            descriptionMessage: messages.descriptionMessageIcal,
            path: '/ical',
            titleMessage: messages.titleMessageIcal,
        },
    ],
    component: lazy(() => import('../../pages/faq-page/faq-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/faq',
    titleMessage: messages.titleMessage,
}
